var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1C1.22386 1 1 1.22386 1 1.5V10.5C1 10.7761 1.22386 11 1.5 11H10.5C10.7761 11 11 10.7761 11 10.5V6C11 5.72386 11.2239 5.5 11.5 5.5C11.7761 5.5 12 5.72386 12 6V10.5C12 11.3284 11.3284 12 10.5 12H1.5C0.671573 12 0 11.3284 0 10.5V1.5C0 0.671573 0.671573 0 1.5 0H6C6.27614 0 6.5 0.223858 6.5 0.5C6.5 0.776142 6.27614 1 6 1H1.5ZM8.5 0.5C8.5 0.223858 8.72386 0 9 0H11.5C11.7761 0 12 0.223858 12 0.5V3C12 3.27614 11.7761 3.5 11.5 3.5C11.2239 3.5 11 3.27614 11 3V1.70711L5.70711 7H7C7.27614 7 7.5 7.22386 7.5 7.5C7.5 7.77614 7.27614 8 7 8H4.5C4.22386 8 4 7.77614 4 7.5V5C4 4.72386 4.22386 4.5 4.5 4.5C4.77614 4.5 5 4.72386 5 5V6.29289L10.2929 1H9C8.72386 1 8.5 0.776142 8.5 0.5Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenExternal);
export default __webpack_public_path__ + "static/media/open-external.279c497f82cf79f19bce968d4d44c2fd.svg";
export { ForwardRef as ReactComponent };